// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchArea[data-v-3b111353]{\n  align-items: normal !important;\n}\n[data-v-3b111353] .tbl-type01.style03\nth {\n    background: #ececec !important;\n}\n[data-v-3b111353] .type3{\n    border: 1px solid lightgray;\n}\n[data-v-3b111353] tr.v-data-table__selected {\n    background:  lightgray !important;\n}\n[data-v-3b111353].form-input.v-text-field--outlined .v-messages__message {\n    color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
